<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      class="mb-4"
    >
      <v-tab :to="{ name: 'AnalyticsFunnel' }">
        Воронка
      </v-tab>
      <v-tab :to="{ name: 'AnalyticsSources' }">
        Источники
      </v-tab>
      <v-tab :to="{ name: 'AnalyticsCustomers' }">
        Клиенты
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AnalyticsIndex',
  data() {
    return { tab: null }
  },
}
</script>
